import { FC } from "react";
import { Animated, Button, Warning } from "rujira.ui";

export const AnalyticsWarning: FC<{ onRetry: () => void }> = ({ onRetry }) => (
  <Warning
    className="warning--sm warning--borderless condensed flex ai-c"
    color="orange">
    <Animated
      name="api-error"
      className="color-orange block no-shrink"
      style={{ width: "2rem", height: "2rem" }}
    />
    <div className="text-left fs-14">
      The analytics are currently unavailable.
    </div>
    <Button
      className="button--xs button--outline button--orange"
      label="Retry"
      onClick={onRetry}
    />
  </Warning>
);
